import { createSvgIcon } from "@mui/material";

const VkLogoIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='4 4 40 40'
    width='48px'
    height='48px'>
    <path
      fill='#1976d2'
      d='M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z'
    />
    <path
      fill='#fff'
      // eslint-disable-next-line max-len
      d='M25.2,33.2c-9,0-14.1-6.1-14.3-16.4h4.5c0.1,7.5,3.5,10.7,6.1,11.3V16.8h4.2v6.5c2.6-0.3,5.3-3.2,6.2-6.5h4.2	c-0.7,4-3.7,7-5.8,8.2c2.1,1,5.5,3.6,6.7,8.2h-4.7c-1-3.1-3.5-5.5-6.8-5.9v5.9H25.2z'
    />
  </svg>,
  "VkLogo"
);

export default VkLogoIcon;
